<!-- Tabbed header -->
<ng-container *ngIf="showSearchTabs">
  <!-- Tabs -->
  <dgx-search-tabs>
    <div
      class="l_flex guts-p-h-1-half guts-p-t-3 guts-p-b-2 m-guts-p-v-1"
      [ngClass]="{
        'l_flex-justify-center': !isPhone,
        'm-l_flex l_flex-column': isPhone
      }"
    >
      <!-- Title, Search Field, & Org Selector -->
      <ng-container *ngTemplateOutlet="searchAndOrgSelector"></ng-container>
    </div>
  </dgx-search-tabs>
</ng-container>

<!-- Non-tabbed header (deprecated) -->
<ng-container *ngIf="!showSearchTabs">
  <!-- Back link -->
  <div class="guts-p-h-1-half guts-m-v-3">
    <a
      href=""
      class="link par par--small"
      (click)="backClick($event)"
      data-dgat="search-landing-page-179"
    >
      <df-icon icon="chevron-left" aria-hidden="true" class="v-super"></df-icon
      >{{ 'Core_Back' | translate }}
    </a>
  </div>

  <!-- Title, Search Field, & Org Selector -->
  <div class="guts-p-h-1-half">
    <h1 class="h1" *ngIf="title; else titleSkeleton">{{ title }}</h1>
    <div
      class="l_flex guts-p-t-3 guts-p-b-2 m-guts-p-v-1"
      [ngClass]="{
        'l_flex-justify-center': !isPhone,
        'm-l_flex l_flex-column': isPhone
      }"
    >
      <ng-container *ngTemplateOutlet="searchAndOrgSelector"></ng-container>
    </div>
  </div>
</ng-container>

<!-- Custom layout (override default paginated layout - Opportunities only at this time)-->
<ng-container *ngIf="customLayout; else defaultLayout">
  <ng-content></ng-content>
</ng-container>

<!-- Default layout template-->
<ng-template #defaultLayout>
  <ng-container *ngIf="!showNoResults; else noResults">
    <ng-container
      *ngIf="
        !hasNoResultsFullPage ||
          isLoading ||
          (!isLoading && totalNumResults) ||
          (!isLoading && !totalNumResults && term);
        else noResultsFullPage
      "
    >
      <div class="guts-p-h-1-half">
        <ng-container *ngIf="!hideFilters && !useFilterSidebar">
          <!-- The if statement on the search filters component is used to display the component's skeleton while loading -->
          <dgx-search-filters
            *ngIf="isLoading || totalNumResults > 0"
            #searchFilters
            dgxSticky
            stickyCustomClass="box-shadow guts-p-full-1 bg-color-ebony-a03-hue"
            notStickyCustomClass="guts-m-b-3"
            [defaultFilterIds]="defaultFilterIds"
            [filterIdsToIgnore]="filterIdsToIgnore"
            [filters]="filters"
            [numberOfSkeletonColumns]="numberOfFilterSkeletonColumns"
            [isLoading]="isLoading"
            [usesGlobalSearchApi]="usesGlobalSearchApi"
            (filtersChange)="applyFilters()"
          ></dgx-search-filters>
        </ng-container>
      </div>

      <!-- New layout (sidebar filters) -->
      <div
        class="grid"
        *ngIf="showSearchLayoutRedesign && !hideFilters && useFilterSidebar"
      >
        <div class="no-phone grid__col-xs-4 grid__col-sm-4 grid__col-md-3">
          <!-- Sidebar filters -->
          <dgx-search-filters-sidebar
            *ngIf="!hideFilters && useFilterSidebar"
            [filters]="filters"
            [isLoading]="isLoading"
            [showFilterReset]="showFilterReset"
            (filtersChange)="updateFilters($event)"
            (resetFilters)="resetFilters()"
          ></dgx-search-filters-sidebar>
        </div>
        <div class="grid__col-xs-8 grid__col-sm-8 grid__col-md-9">
          <!-- Results count header & sort dropdown -->
          <ng-container *ngTemplateOutlet="resultsHeader"></ng-container>

          <!-- Results & Pagination -->
          <div class="sidebarResults">
            <ng-container
              *ngTemplateOutlet="resultsAndPagination"
            ></ng-container>

            <!-- Mobile Filters -->
            <dgx-search-mobile-filters
              class="phone-only"
              [isLoading]="isLoading"
              [filters]="filters"
              [showFilterReset]="showFilterReset"
              (filtersChange)="updateFilters($event)"
              (resetFilters)="resetFilters()"
            ></dgx-search-mobile-filters>
          </div>
        </div>
      </div>

      <!-- Deprecated layout (no sidebar filters) -->
      <ng-container
        *ngIf="!showSearchLayoutRedesign || hideFilters || !useFilterSidebar"
      >
        <!-- Results count header & sort dropdown -->

        <!-- New  header -->
        <ng-container *ngIf="showSearchLayoutRedesign">
          <div class="guts-p-h-1-half">
            <ng-container *ngTemplateOutlet="resultsHeader"></ng-container>
          </div>
        </ng-container>

        <!-- Deprecated header-->
        <ng-container *ngIf="!showSearchLayoutRedesign && !isLoading">
          <div class="guts-m-b-half guts-p-h-1-half l_flexbar">
            <span class="par par--small par--light_a font-semibold l_flex-grow">
              {{ resultsRange }}
            </span>

            <div
              *ngIf="showSort"
              class="
                par par--small par--light_a
                font-bold
                l_flex l_flex-justify-right
              "
            >
              {{ 'Core_SortBy' | translate }}
              <dgx-menu
                [menuConfig]="menuConfig"
                placement="bottom-right"
                class="guts-m-l-half"
              >
                <button
                  type="button"
                  [attr.aria-label]="'Core_MoreOptions' | translate"
                  data-dgat="search-results-e2c"
                  class="par par--small color-blue"
                >
                  {{ sortButtonText }}
                  <df-icon icon="chevron-down" size="small"></df-icon>
                </button>
              </dgx-menu>
            </div>
          </div>
        </ng-container>

        <!-- Results & Pagination -->
        <ng-container *ngTemplateOutlet="resultsAndPagination"></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<dgx-footer-glasses></dgx-footer-glasses>

<!-- Search & Org Selector template -->
<ng-template #searchAndOrgSelector>
  <div
    class="l_flex-grow"
    [ngClass]="{
      'guts-p-b-1': isMobile,
      'guts-m-r-2': !isMobile && showOrgSelector
    }"
  >
    <!-- Search Field -->
    <dgx-search-initiation-autocomplete
      *ngIf="showSearchInitiationAutocomplete"
      (inputEnter)="inputEntered($event)"
      [termSuggestionsOnly]="true"
      [searchTerm]="term"
      [showDefaults]="true"
      [initiationLocation]="initiationLocation"
      size="large"
    ></dgx-search-initiation-autocomplete>
    <!-- Deprecated Search Field-->
    <dgx-simple-search-suggest
      *ngIf="!showSearchInitiationAutocomplete"
      [searchTerm]="term"
      [showDefaults]="showDefaultSuggestions"
      [suggestionSource]="suggestionSource"
      (inputEnter)="inputEntered($event)"
    ></dgx-simple-search-suggest>
  </div>
  <div *ngIf="showOrgSelector">
    <!-- Org Selector -->
    <dgx-org-selector
      [ngClass]="{
        'l_flex-center full-width': isPhone
      }"
      [defaultOrgId]="orgId"
      [orgs]="catalogs"
      [selectedOrg]="selectedCatalog"
      (selectedOrgChange)="onCatalogChange($event)"
    ></dgx-org-selector>
  </div>
</ng-template>

<!-- Results Header template -->
<ng-template #resultsHeader>
  <dgx-search-results-header
    [isLoading]="isLoading"
    [headerText]="'Core_Results' | translate"
    [totalContentResults]="totalNumResults"
    [pageNum]="pageNum"
    [numResultsPerPage]="numResultsPerPage"
    [hideSort]="!showSort"
    [sortBy]="currentSort"
    (sortChange)="doSort($event)"
  ></dgx-search-results-header>
</ng-template>

<!-- Results & Pagination template -->
<ng-template #resultsAndPagination>
  <ng-container *ngIf="!isLoading; else resultsSkeleton">
    <!-- Results -->
    <ng-content select="#results"></ng-content>
    <!-- Pagination -->
    <div
      class="center-text guts-p-v-1-half"
      *ngIf="totalNumResults > numResultsPerPage"
    >
      <dgx-pagination
        [page]="pageNum"
        [collectionSize]="totalNumResults"
        [ellipses]="false"
        [boundaryLinks]="true"
        [maxSize]="8"
        [pageSize]="numResultsPerPage"
        [rotate]="true"
        (pageChange)="goToPage($event)"
      >
      </dgx-pagination>
    </div>
  </ng-container>
</ng-template>

<ng-template #titleSkeleton>
  <dgx-skeleton type="title"></dgx-skeleton>
</ng-template>

<!-- Results Skeleton template-->
<ng-template #resultsSkeleton>
  <div class="grid">
    <div
      *ngFor="let skeleton of resultsSkeletons"
      class="grid__col-xs-6 grid__col-sm-4"
      data-dgat="search-landing-page-996"
    >
      <dgx-skeleton type="tile"></dgx-skeleton>
    </div>
  </div>
</ng-template>

<!-- No Results/Error (something went wrong) template-->
<ng-template #noResults>
  <dgx-search-no-results
    [searchTerm]="term"
    [hasError]="hasError"
  ></dgx-search-no-results>
</ng-template>

<!-- No Results Full Page template-->
<ng-template #noResultsFullPage>
  <ng-content select="#noResultsFullPage"></ng-content>
</ng-template>
